/**
 * 
 * @param {string} language 
 */
export const changeLanguage = (language) => {
    let url = new URL(window.location.href);
    url.searchParams.set('lang', language)
    window.location.replace(url.href);
}